var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8901 5.08039C14.0201 4.82039 13.0601 4.65039 12.0001 4.65039C7.21008 4.65039 3.33008 8.53039 3.33008 13.3204C3.33008 18.1204 7.21008 22.0004 12.0001 22.0004C16.7901 22.0004 20.6701 18.1204 20.6701 13.3304C20.6701 11.5504 20.1301 9.89039 19.2101 8.51039",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1302 5.32L13.2402 2",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1298 5.32031L12.7598 7.78031",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1889 19C10.3074 19 9.64198 18.764 9.19259 18.2921C8.74321 17.8202 8.51852 17.1545 8.51852 16.2949V14.5C9.33951 14.5 9.99198 14.4747 10.4759 14.4242C10.9685 14.3736 11.3358 14.2725 11.5778 14.1208C11.8198 13.9607 11.9796 13.7247 12.0574 13.4129C12.1352 13.1011 12.1741 12.684 12.1741 12.1615V10.5056H13.3926V12.1489C13.3926 12.7388 13.3321 13.2402 13.2111 13.6531C13.0901 14.066 12.8914 14.3989 12.6148 14.6517C12.3383 14.9045 11.9623 15.0899 11.487 15.2079C11.0204 15.3174 10.437 15.3722 9.73704 15.3722V16.3708C9.73704 16.868 9.84506 17.2683 10.0611 17.5716C10.2772 17.8666 10.6531 18.014 11.1889 18.014C11.6901 18.014 12.0488 17.875 12.2648 17.5969C12.3908 17.4409 12.4815 17.2505 12.5369 17.0255C12.6156 16.7056 12.8689 16.434 13.1984 16.434V16.434C13.5327 16.434 13.8088 16.7106 13.7509 17.0399C13.6554 17.5832 13.4409 18.0175 13.1074 18.3427C12.6667 18.7809 12.0272 19 11.1889 19ZM8.5 13C8.22386 13 8 12.7761 8 12.5V12.5C8 12.2239 8.22386 12 8.5 12H14.5C14.7761 12 15 12.2239 15 12.5V12.5C15 12.7761 14.7761 13 14.5 13H8.5ZM8.5 11C8.22386 11 8 10.7761 8 10.5V10.5C8 10.2239 8.22386 10 8.5 10H14.5C14.7761 10 15 10.2239 15 10.5V10.5C15 10.7761 14.7761 11 14.5 11H8.5Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/Refund.84301aab1000d494d5da847897853499.svg";
export { ForwardRef as ReactComponent };